import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Globle } from 'src/assets/globle';
import { QRFeesCategory } from './qrfeescategory.model';

@Injectable({
  providedIn: 'root'
})
export class QrfeescategoryService {

  constructor(private http: HttpClient, private global: Globle) { }

  getAllCategory() {
    return this.http.get<[]>(this.global.APIURLV2 + "qrcategoryprices/getallcategory");
  }

  getByCategory(categoryId: number) {
    return this.http.get<[]>(this.global.APIURLV2 + "qrcategoryprices/getbycategory/" + categoryId);
  }

  CreateCategory(obj: any) {
    return this.http.post(this.global.APIURLV2 + "qrcategoryprices/createcategory", obj)
  }

  UpdateCategory(obj: any) {
    return this.http.put<any>(this.global.APIURLV2 + "qrcategoryprices/updatecategory", obj)
  }

  saveCategoryPrices(obj: any) {
    return this.http.post<any>(this.global.APIURLV2 + "qrcategoryprices/savefees", obj)
  }
}
